import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import { loginIn } from './getData';
import { LOGIN_IN } from './mutation-types'

Vue.use(Vuex);

import mutations from './mutation'
import actions from './action'

export default new Vuex.Store({
  state: {
    account: {
      email: '',  //  用户登录邮箱
      loginSuccess: '', //登录
      loginStatus: false, // 记录登录状态
    },
    user: {
      key: '',
      secret: '',
      email: '', 
    },
    service: {
      lineCount: '',
      name: '-',
      ports: '',
      serviceList: '',
      serviceLogs: [],
      total: '',
      serviceRate: []
    },
  },
  mutations,
  actions,
});

